export const MIXPANEL_EVENTS = {
  USER_LOGIN_SUCCESS: 'user_login_success',
  DASHBOARD_VIEWED: 'dashboard_viewed',
  DASHBOARD_TITLE_CLICKED: 'dashboard_title_clicked',
  STUDIO_DASHBOARD_CLICKED: 'studio_dashboard_clicked',
  STUDIO_NEW_GRAPH_CLICKED: 'studio_new_graph_clicked',
  STUDIO_GRAPH_LOAD_CLICKED: 'studio_graph_load_clicked',
  STUDIO_GRAPH_SAVE_CLICKED: 'studio_graph_save_clicked',
  STUDIO_GRAPH_PUBLISH_CLICKED: 'studio_graph_publish_clicked',
  STUDIO_GRAPH_COPY_CLICKED: 'studio_graph_copy_clicked',
  STUDIO_GRAPH_RESET: 'studio_graph_reset',
  STUDIO_CONTENT_UPLOADED: 'studio_content_uploaded',
  STUDIO_CONTENT_DRAWER_OPENED: 'studio_content_drawer_opened',
  TENANT_SWITCHED: 'tenant_switched'
};

export const MIXPANEL_EVENT_METADATA = {
  [MIXPANEL_EVENTS.USER_LOGIN_SUCCESS]: {
    event_category: 'Authentication',
    event_action: 'Login Success'
  },
  [MIXPANEL_EVENTS.DASHBOARD_VIEWED]: {
    event_category: 'Dashboard',
    event_action: 'Dashboard Viewed'
  },
  [MIXPANEL_EVENTS.DASHBOARD_TITLE_CLICKED]: {
    event_category: 'Dashboard',
    event_action: 'Title Clicked'
  },
  [MIXPANEL_EVENTS.STUDIO_DASHBOARD_CLICKED]: {
    event_category: 'Studio',
    event_action: 'Dashboard Clicked'
  },
  [MIXPANEL_EVENTS.STUDIO_NEW_GRAPH_CLICKED]: {
    event_category: 'Studio',
    event_action: 'New Graph Clicked'
  },
  [MIXPANEL_EVENTS.STUDIO_GRAPH_LOAD_CLICKED]: {
    event_category: 'Studio',
    event_action: 'Graph Loaded'
  },
  [MIXPANEL_EVENTS.STUDIO_GRAPH_SAVE_CLICKED]: {
    event_category: 'Studio',
    event_action: 'Graph Saved'
  },
  [MIXPANEL_EVENTS.STUDIO_GRAPH_PUBLISH_CLICKED]: {
    event_category: 'Studio',
    event_action: 'Graph Published'
  },
  [MIXPANEL_EVENTS.STUDIO_GRAPH_COPY_CLICKED]: {
    event_category: 'Studio',
    event_action: 'Graph Copied'
  },
  [MIXPANEL_EVENTS.STUDIO_GRAPH_RESET]: {
    event_category: 'Studio',
    event_action: 'Graph Reset'
  },
  [MIXPANEL_EVENTS.STUDIO_CONTENT_UPLOADED]: {
    event_category: 'Studio',
    event_action: 'Content Uploaded'
  },
  [MIXPANEL_EVENTS.STUDIO_CONTENT_DRAWER_OPENED]: {
    event_category: 'Studio',
    event_action: 'Content Drawer Opened'
  },
  [MIXPANEL_EVENTS.TENANT_SWITCHED]: {
    event_category: 'Tenant',
    event_action: 'Tenant Switched'
  }
};
